export default __webpack_public_path__ + "static/media/weeztarget-logo.0936ffdb.png";